import { Link } from 'react-router';

import logo from '@/images/header/logo.svg';

import s from './logo.module.css';

function Logo() {
  return (
    <Link to="/" className={s.logo}>
      <img src={logo} alt="logo" />
      <p>GoVPSFX</p>
    </Link>
  );
}

export default Logo;
